import React from 'react';
import HomeIcon from '@mui/icons-material/Home';
import { useShadowStyle } from 'hooks/useShadowStyle';
import { MapIconContainer } from '../MapIconContainer';

const Home = () => {
    const shadowStyle = useShadowStyle();
    return (
        <MapIconContainer>
            <HomeIcon
                sx={{
                    ...shadowStyle,
                }}
                fontSize="large"
            />
        </MapIconContainer>
    );
};

export default Home;
